import { render, staticRenderFns } from "./shortPlayer.vue?vue&type=template&id=54acb8eb&scoped=true&"
import script from "./shortPlayer.ts?vue&type=script&lang=js&"
export * from "./shortPlayer.ts?vue&type=script&lang=js&"
import style0 from "./shortPlayer.less?vue&type=style&index=0&id=54acb8eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54acb8eb",
  null
  
)

export default component.exports